import actionTypes from '../constants/action-types';

const finishPublishing = ({ siteUrl, withUpsell, isPublished, partnerId, isThirdPartyDomain }) => ({
  type: actionTypes.FINISH_PUBLISHING,
  payload: {
    siteUrl,
    withUpsell,
    isPublished,
    partnerId,
    isThirdPartyDomain,
  },
});

export default finishPublishing;
